import {
  ITimesheetCopyLastWeekRequestDTO,
  ICreateTimesheetDashboardEntryRequestDTO,
  ITimesheetDashboardDTO,
  ITimesheetDashboardRequestDTO,
  ITimesheetDashboardSummaryDTO,
  ITimesheetDashboardSummaryRequestDTO,
  ITimesheetDTO,
  ITimesheetRequestDTO,
  ITimesheetSubmitRequestDTO,
  ITimesheetSummaryDTO,
  ITimesheetSummaryRequestDTO,
  ITimesheetUpdateRequestDTO,
} from 'src/api/dtos';
import { IPayPeriodWeekDTO } from 'src/api/dtos/payPeriodWeek.dto';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import api from 'src/api/rtk/rtk-api';
import { IListQueryResult, IQueryResult } from 'src/api/types';

export default class TimesheetRepository extends ESSRepository {
  private static readonly baseRoute = '/timesheets';
  private static readonly apiURL = TimesheetRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getTimesheetPayPeriodWeeks: build.query<IPayPeriodWeekDTO[], void>({
        query: () => {
          return { url: `${this.apiURL}/payperiodweeks`, method: 'get' };
        },
        transformResponse: (response: IListQueryResult<IPayPeriodWeekDTO>) => response.items,
      }),
      getTimesheetGrid: build.query<ITimesheetDTO, ITimesheetRequestDTO>({
        query: (params) => {
          return { url: `${this.apiURL}/grid`, method: 'get', params };
        },
        transformResponse: (response: IQueryResult<ITimesheetDTO>) => response.item,
        providesTags: ['Timesheet'],
      }),
      getCopyLastWeek: build.query<ITimesheetDTO, ITimesheetCopyLastWeekRequestDTO>({
        query: (params) => {
          return { url: `${this.apiURL}/grid/copylastweek`, method: 'get', params };
        },
        transformResponse: (response: IQueryResult<ITimesheetDTO>) => response.item,
        providesTags: ['Timesheet'],
      }),
      updateTimesheetGrid: build.mutation<ITimesheetDTO, ITimesheetUpdateRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/grid`, method: 'patch', data };
        },
        transformResponse: (response: IQueryResult<ITimesheetDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Timesheet']),
      }),
      submitTimesheet: build.mutation<ITimesheetDTO, ITimesheetSubmitRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/submit`, method: 'patch', data };
        },
        transformResponse: (response: IQueryResult<ITimesheetDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Timesheet']),
      }),
      getTimesheetGridSummary: build.query<ITimesheetSummaryDTO, ITimesheetSummaryRequestDTO>({
        query: (params) => {
          return { url: `${this.apiURL}/grid/summary`, method: 'get', params };
        },
        transformResponse: (response: IQueryResult<ITimesheetSummaryDTO>) => response.item,
        providesTags: ['Timesheet'],
      }),
      getTimesheetDashboards: build.query<ITimesheetDashboardDTO, ITimesheetDashboardRequestDTO>({
        query: (params) => {
          return { url: this.apiURL, method: 'get', params };
        },
        transformResponse: (response: IQueryResult<ITimesheetDashboardDTO>) => response.item,
        providesTags: ['Timesheet'],
      }),
      createTimesheetDashboardEntry: build.mutation<ITimesheetDashboardDTO, ICreateTimesheetDashboardEntryRequestDTO>({
        query: (data) => {
          return { url: this.apiURL, method: 'post', data };
        },
        transformResponse: (response: IQueryResult<ITimesheetDashboardDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Timesheet']),
      }),
      getTimesheetDashboardSummary: build.query<ITimesheetDashboardSummaryDTO, ITimesheetDashboardSummaryRequestDTO>({
        query: (params) => {
          return { url: `${this.apiURL}/summary`, method: 'get', params };
        },
        transformResponse: (response: IQueryResult<ITimesheetDashboardSummaryDTO>) => response.item,
        providesTags: ['Timesheet'],
      }),
    }),
  });
}
